import { BlockNodes, IMenuButton } from '@principle-theorem/editor';
import { type MenuButtonLoaderFn } from '@principle-theorem/ng-prosemirror';
import { Editor } from '@tiptap/core';
import { FontFamilyMenuComponent } from './font-family-menu/font-family-menu.component';

export function createFontFamilyMenuButton(
  defaultFont?: string
): MenuButtonLoaderFn<FontFamilyMenuComponent, IMenuButton> {
  return () => ({
    component: FontFamilyMenuComponent,
    data: {
      buttonType: 'submenu-detail',
      canActivateFn: (editor: Editor) =>
        editor.isActive(BlockNodes.Heading) ||
        editor.isActive(BlockNodes.Paragraph),
      buttonText: '',
      icon: '',
      tooltip: '',
      command: () => {
        //
      },
      ...(defaultFont !== undefined ? { defaultFont } : {}),
    },
  });
}
